import { helper } from '@ember/component/helper';
import prettyUrl from '../utils/pretty-url';

export default helper(function (positional /*, named*/) {
  let [url] = positional;

  return prettyUrl(url);
});